const messages = {
  logout: 'Вы вышли из системы',
  login: 'Для начала войдите в систему',
  422: 'Указанные данные неверны',
};
export { messages };
